export default __webpack_public_path__ + "static/media/presenceIcon.947e30e2.svg";